import React from "react";
import { Link } from "react-router-dom";
import { Search, Heart, PartyPopper, Trophy, Crown, Camera, ArrowUpRight } from "lucide-react";

/**
 * FanJourney — editorial numbered index (magazine style).
 * Two accent colours only (lime + magenta) so the page stops shouting.
 */
const STEPS = [
  { n: "01", icon: Search, title: "Find events", desc: "College fests, concerts, house parties — filtered to your city and your vibe.", to: "/#events-grid", testId: "journey-find" },
  { n: "02", icon: Heart, title: "Match people", desc: "ClubVIP matchmaking, private-by-default, scoped to the crowd at your event.", to: "/clubvip", testId: "journey-match", accent: true },
  { n: "03", icon: PartyPopper, title: "Show up. Vibe.", desc: "QR entry, live count at the gate, and a live gallery of the night.", to: "/#events-grid", testId: "journey-vibe" },
  { n: "04", icon: Trophy, title: "Win the room", desc: "Contests and giveaways from every brand we work with — no strings.", to: "/contests", testId: "journey-win" },
  { n: "05", icon: Crown, title: "Unlock VIP", desc: "After-parties, house parties, and access the crowd will never see.", to: "/vip", testId: "journey-vip", accent: true },
  { n: "06", icon: Camera, title: "Find your photos", desc: "AI Gallery — one selfie pulls every shot of you from the night.", to: "/ai-gallery", testId: "journey-photos" },
];

export default function FanJourney() {
  return (
    <section className="relative border-t border-b border-line" data-testid="fan-journey">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="text-[10px] font-mono tracking-[0.35em] uppercase text-lime">The Eventom index</div>
            <h2 className="mt-3 font-fancy text-4xl sm:text-5xl md:text-6xl leading-[0.9]">
              Six chapters.<br className="hidden md:block" /> One <em className="not-italic grad-text-hot">unforgettable</em> night.
            </h2>
          </div>
          <p className="text-sm text-muted md:max-w-xs md:text-right">
            Every fan on Eventom follows the same story. Skip to any chapter.
          </p>
        </div>

        <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-white/10 border-t border-white/10">
          {STEPS.map((s) => (
            <Link key={s.n} to={s.to} data-testid={s.testId}
              className="group relative p-6 md:p-8 flex gap-5 hover:bg-white/[0.02] transition-colors border-b border-white/10 last:border-b-0">
              <div className="shrink-0">
                <div className={`font-fancy text-4xl md:text-5xl leading-none ${s.accent ? "text-magenta" : "text-white/25"}`}>{s.n}</div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <s.icon className={`w-4 h-4 ${s.accent ? "text-magenta" : "text-lime"}`} strokeWidth={2.5} />
                  <div className="font-heading font-bold text-lg uppercase tracking-tight">{s.title}</div>
                </div>
                <div className="text-sm text-muted mt-2 leading-relaxed">{s.desc}</div>
              </div>
              <ArrowUpRight className="w-4 h-4 text-white/30 self-start mt-1 transition-all group-hover:text-lime group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
